var transformOrganizationModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import {
  PopoverGroupOptionsMixin
} from 'trunks/vue/admin/components/popover_group_options.js';

export default transformOrganizationModal = Vue.extend({
  mixins: [PopoverGroupOptionsMixin],
  components: {
    "modal": Modal,
    'Popover': Popover
  },
  props: {
    organization: {
      type: Object,
      require: true
    },
    updateOrganizationFounder: {
      type: Function
    }
  },
  data: function() {
    return {
      selectedUser: null
    };
  },
  template: `<modal :title='"组织移交"' :extendClass='"transform-organization-modal"' ref="modal">
  <div class="modal-body">
    <div class="list">
      <div class="list-item">
        <div class="tip">选择要移交的人</div>
        <div class="content">
          <Popover :position='"top"'
                   :caret='false'
                   :blockContent='true'
                   @beforeClose="resetPopoverGroupOptionsRef"
                   customClass='search-user-radio select'
                   ref='popoverVm'>
            <template slot='trigger'>
              <div class="input-control right-addon justify-box" ref='searchInput'>
                <div class="controlled-input">{{ displayValue }}</div>
                <div class="addon">
                  <i class="slp-caret-down"></i>
                </div>
              </div>
            </template>
            <template slot='content'>
              <popover-group-options optionsFilterPlaceholder='搜索用户'
                                     :multiple='false'
                                     :formatDataFunc='formatDataFunc'
                                     :needFooter='false'
                                     @valueChanged='valueChangedFunc'
                                     @keywordUpdated='keywordUpdatedFunc'
                                     @cancelClicked='userSelectCancelFunc'
                                     @submitClicked='submitFunc'
                                     ref='popoverGroupOptionsRef'>
              </popover-group-options>
            </template>
          </Popover>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer" slot="footer">
    <button class="outlined btn-default" @click='modalCancel'>取消</button>
    <button @click='doRequest'>确定</button>
  </div>
</modal>`,
  computed: {
    displayValue: function() {
      if (this.selectedUser) {
        return this.selectedUser.name;
      } else {
        return '';
      }
    }
  },
  methods: {
    formatDataFunc: function() {
      return [];
    },
    submitFunc: function() {
      this.userSelectCancelFunc();
      return this.resetPopoverGroupOptionsRef();
    },
    userSelectCancelFunc: function() {
      return this.$refs.popoverVm.close();
    },
    resetPopoverGroupOptionsRef: function() {
      return this.$refs.popoverGroupOptionsRef.reset();
    },
    modalCancel: function() {
      return this.$refs.modal.close();
    },
    keywordUpdatedFunc: function(keyword) {
      return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.adminUrlFor('users/query', {
        name: keyword
      }), {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: (data, xhr) => {
          return this.$refs.popoverGroupOptionsRef.updateGroupedOptions([
            {
              id: Skylark.Helpers.Utilities.uuid(),
              options: _.each(data,
            (item) => {
                var ref;
                return item._selected = ((ref = this.selectedUser) != null ? ref.id : void 0) === item.id;
              })
            }
          ]);
        }
      });
    },
    doRequest: function() {
      if (!this.selectedUser) {
        return;
      }
      return Skylark.Libs.Ajax.put(Skylark.Helpers.UrlHelper.adminUrlFor(`/organizations/${this.organization.id}/transfer/${this.selectedUser.id}`), {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        success: () => {
          Skylark.Bridge.newAlertify('组织移交成功', {
            type: 'success'
          });
          this.modalCancel();
          return this.updateOrganizationFounder(this.selectedUser);
        },
        error: function() {
          return Skylark.Bridge.newAlertify('组织移交失败', {
            type: 'error'
          });
        }
      });
    },
    valueChangedFunc: function(option) {
      if (this.selectedUser === option) {
        option._selected = false;
        return this.selectedUser = null;
      } else {
        this.selectedUser = option;
        return option._selected = true;
      }
    }
  }
});
